import Alpine from 'alpinejs';

Alpine.data('splitview', () => ({
    init() {
        this.container = document.querySelector('.split-view');
        this.handle = document.querySelector('.split-view__handle');
        this.active = false; // Track if the user is dragging

        // Mouse event listeners
        this.handle.addEventListener('mousedown', () => (this.active = true));
        document.addEventListener('mouseup', () => (this.active = false));
        document.addEventListener('mousemove', (e) => this.handleMove(e));

        // Touch event listeners for mobile support
        this.handle.addEventListener('touchstart', () => (this.active = true));
        document.addEventListener('touchend', () => (this.active = false));
        document.addEventListener('touchmove', (e) => this.handleMove(e.touches[0]));
    },
    handleMove(e) {
        if (!this.active) {
            this.handle.classList.remove('is-drugging');
            return;
        }

        // Get the position of the container and the mouse/touch position
        const containerRect = this.container.getBoundingClientRect();
        let x = e.clientX - containerRect.left;

        // Constrain the x position within the container boundaries
        if (x < 0) x = 0;
        if (x > containerRect.width) x = containerRect.width;

        // Update the CSS variable to move the handle and clip the image
        this.handle.classList.add('is-drugging');
        this.container.style.setProperty('--default-position', `${x}px`);
    },
}));
